import { capitalize } from "@/services/helper";

export default {
  methods: {
    /**
     * Método genérico para cambiar el estado de un programa de paciente
     * @param {Object} programPatient - El programa de paciente
     * @param {Object} config - Configuración del modal y acción
     * @param {string} config.title - Título del modal
     * @param {string} config.actionWord - Palabra de acción (aprobar, rechazar, etc.)
     * @param {string} config.status - Estado objetivo (active, rejected, cancelled, completed)
     * @param {string} config.confirmButtonText - Texto del botón de confirmación
     */
    async changeProgramPatientStatus(programPatient, config) {
      const { title, actionWord, status, confirmButtonText } = config;

      const patientName = `${capitalize(
        programPatient.patient.firstName
      )} ${capitalize(programPatient.patient.lastName)}`;
      const programName = programPatient.program.name;

      const h = this.$createElement;

      this.$msgbox({
        title,
        message: h("div", [
          h(
            "p",
            { style: "margin-bottom: 15px" },
            `¿Está seguro que desea ${actionWord} el programa "${programName}" para el paciente ${patientName}?`
          ),
          h(
            "label",
            { style: "font-weight: 600; display: block; margin-bottom: 8px" },
            "Dictámen *"
          ),
          h("textarea", {
            domProps: {
              placeholder: "Ingrese el dictámen...",
              rows: 4,
            },
            style: {
              width: "100%",
              padding: "8px",
              marginBottom: "10px",
              border: "1px solid #dcdfe6",
              borderRadius: "4px",
              resize: "vertical",
              fontFamily: "inherit",
              fontSize: "14px",
            },
            ref: "dictamenInput",
          }),
        ]),
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText: "Volver",
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            const textarea = instance.$el?.querySelector?.("textarea");
            const dictamen = textarea?.value || "";

            if (!dictamen || !dictamen.trim()) {
              this.$message.warning("El dictámen es requerido");
              return;
            }

            await this.updateProgramPatientStatus(programPatient, status, {
              judgment: dictamen,
            });
            const textareaAfter = instance.$el?.querySelector?.("textarea");
            if (textareaAfter) textareaAfter.value = "";
          } else {
            const textarea = instance.$el?.querySelector?.("textarea");
            if (textarea) textarea.value = "";
          }
          done();
        },
        // eslint-disable-next-line prettier/prettier
      }).catch(() => {});
    },
  },
};
